import styled from "@emotion/styled";
import { LightMode } from "@repo/skapa";
import ReactMarkdown, { type Options } from "react-markdown";

type MarkdownProps = Options;

const MarkdownStyles = styled.div`
  color: ${LightMode.colourTextAndIcon1};

  ul {
    list-style: inside;
  }
`;

export const Markdown = (props: MarkdownProps) => {
  return (
    <MarkdownStyles>
      <ReactMarkdown {...props} />
    </MarkdownStyles>
  );
};
